import React, { Component, useRef } from "react";
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../../assets/img/svg/save.svg';
import del from "../../../../../assets/img/svg/Del.svg";
import Delete from '../../../../../assets/img/svg/delete.svg';
import Cancel from '../../../../../assets/img/svg/cancel.svg';
import docIcon from '../../../../../assets/img/svg/docIcon.svg';
import { TextField, InputBase, InputAdornment, IconButton, Checkbox } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { useNavigate } from "react-router-dom";
import withRouter from "../../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import $ from "jquery";
import moment from "moment";
import axios from "axios";
import API from "../../../../../_helpers/endpointService"
import { getSettingsFormat } from "../../../../../actions/SettingsAction";

const useStyles = makeStyles((theme) => ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    error: {
        color: '#f44336',
    },
    helperText: {
        '& p': {
            marginLeft: "0px !important"
        }
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
}));

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

class AddHSEQPerform extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            radio: 'sample',
            isMobile: false,
            isError1: false,
            isError2: false,
            isError3: false,
            isError4: false,
            isError5: false,
            isError6: false,
            isError7: false,
            isError8: false,
            isError9: false,
            isError10: false,
            isError11: false,
            isError12: false,
            addData: {
                "Id": 0,
                "ProjectId": "",
                "FromDate": "",
                "ToDate": "",
                "Fatalities": "",
                "LTI": "",
                "LWC": 0,
                "RWC": "",
                "FAC": "",
                "MTC": "",
                "PropertyDamage": "",
                "EnvironmentalDamage": "",
                "MinorOilSpil": "",
                "ChemicalSpil": "",
                "GasLeakage": "",
                "LTIF": "",
                "TRCF": "",
                "Comments": "",
            },
            autoData: {
                "LTIF": 0,
                "TRCF": 0,
                "HSEQPerformanceId": 0
            }
        }
    }
    componentDidMount() {
        this.props.dispatch(getSettingsFormat(this.state.addData.ProjectId))
        window.location.pathname === "/hseq/performance/addnew" ? this.state.isEdit = false : this.state.isEdit = true;
        if (localStorage.getItem("DashId") != 0) {
            this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"))
        } else {
            this.state.addData.ProjectId = parseInt(localStorage.getItem("addeditid"))
        }
        this.getHSEQinfo(this.state.addData.ProjectId)
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }
    DeleteItem = () => {
        const { dispatch } = this.props
        let apiUrl = API.HSEQ_URL + '/' + this.state.id
        dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
        })
            .then((response) => {
                this.props.navigate("/hseq/performance")
                dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.getHSEQinfo(this.state.addData.ProjectId)
                } else {
                }
            })
            .catch((error) => {
                dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {

                }
            });
    };
    getHSEQData = (data) => {
        let apiUrl = API.HSEQ_URL + "/id?id=" + data
        axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.addData.Id = parseInt(this.state.autoData.HSEQPerformanceId);
                    this.state.ProjectId = response.data?.ProjectId;
                    this.state.addData.ProjectId = response.data?.ProjectId ? response.data?.ProjectId : this.state.addData.ProjectId;
                    this.state.addData.FromDate = response.data?.FromDate ? response.data?.FromDate : null;
                    this.state.addData.ToDate = response.data?.ToDate ? response.data?.ToDate : null;
                    this.state.addData.Fatalities = response.data?.Fatalities;
                    this.state.addData.LTI = response.data?.LTI;
                    this.state.addData.RWC = response.data?.RWC;
                    this.state.addData.FAC = response.data?.FAC;
                    this.state.addData.MTC = response.data?.MTC;
                    this.state.addData.PropertyDamage = response.data?.PropertyDamage;
                    this.state.addData.EnvironmentalDamage = response.data?.EnvironmentalDamage;
                    this.state.addData.MinorOilSpil = response.data?.MinorOilSpil;
                    this.state.addData.ChemicalSpil = response.data?.ChemicalSpil;
                    this.state.addData.GasLeakage = response.data?.GasLeakage;
                    this.state.addData.LTIF = response.data?.LTIF;
                    this.state.addData.TRCF = response.data?.TRCF;
                    this.state.addData.Comments = response.data?.Comments;
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });

    };
    getHSEQinfo = (data) => {
        let apiUrl = API.HSEQ_URL + '/projectId?projectId=' + data
        axios({
            method: "get",
            url: apiUrl
        })
            .then((response) => {
                if (response?.status === 200) {
                    response.data.map((i, index) => {
                        if (response.data[index].LTIF !== 0 || response.data[index].TRCF !== 0) {
                            this.state.autoData.LTIF = response.data[index]?.LTIF;
                            this.state.autoData.TRCF = response.data[index]?.TRCF;
                            this.state.autoData.HSEQPerformanceId = response.data[index]?.HSEQPerformanceId;
                        }
                    })
                }
                this.setState({}, () => {
                    if (this.state.isEdit == true) {
                        this.getHSEQData(this.state.autoData.HSEQPerformanceId)
                        this.state.id = this.state.autoData.HSEQPerformanceId
                    }
                })
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        $("#HSEQ1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Hseqper1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Hseqper").addClass("d-none");
        $("#Hseqper").removeClass("d-block");
        $("#HSEQPL").removeClass("active-color");
        $("#HSEQPT").removeClass("fw-bolder");
    }
    handleRadio = (event) => {
        this.state.radio = event.target.value
        this.setState({})
    }
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#HSEQ1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Hseqper1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Hseqper").removeClass("d-none");
        $("#Hseqper").addClass("d-block");
        $("#HSEQPL").addClass("active-color");
        $("#HSEQPT").addClass("fw-bolder");
    }
    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate(`/hseq/performance`)
    };
    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });

            this.props.navigate(`/hseq/performance`)
        }
    }
    handleInputChange = (e, node) => {
        this.state.addData.Id = parseInt(this.state.autoData.HSEQPerformanceId)
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (node === "Comments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData.Comments = e.target.value;
            }
        } else {
            this.state.addData[node] = e.target.value;
            this.setState({})
        }
    }
    AddSave = () => {
        const { addData } = this.state;
        if (addData.ProjectId !== 0 || addData.ProjectId !== undefined) {
            if (addData.FromDate === "") {
                this.state.isError1 = true;
                this.setState({})
            } else {
                this.state.isError1 = false;
                this.setState({})
            }
            if (addData.ToDate === "") {
                this.state.isError2 = true;
                this.setState({})
            } else {
                this.state.isError2 = false;
                this.setState({})
            }
            if (addData.Fatalities === "") {
                this.state.isError3 = true;
                this.setState({})
            } else {
                this.state.isError3 = false;
                this.setState({})
            }
            if (addData.LTI === "") {
                this.state.isError4 = true;
                this.setState({})
            } else {
                this.state.isError4 = false;
                this.setState({})
            }
            if (addData.RWC === "") {
                this.state.isError5 = true;
                this.setState({})
            } else {
                this.state.isError5 = false;
                this.setState({})
            }
            if (addData.FAC === "") {
                this.state.isError6 = true;
                this.setState({})
            } else {
                this.state.isError6 = false;
                this.setState({})
            }
            if (addData.MTC === "") {
                this.state.isError7 = true;
                this.setState({})
            } else {
                this.state.isError7 = false;
                this.setState({})
            }
            if (addData.PropertyDamage === "") {
                this.state.isError8 = true;
                this.setState({})
            } else {
                this.state.isError8 = false;
                this.setState({})
            }
            if (addData.EnvironmentalDamage === "") {
                this.state.isError9 = true;
                this.setState({})
            } else {
                this.state.isError9 = false;
                this.setState({})
            }
            if (addData.MinorOilSpil === "") {
                this.state.isError10 = true;
                this.setState({})
            } else {
                this.state.isError10 = false;
                this.setState({})
            }
            if (addData.ChemicalSpil === "") {
                this.state.isError11 = true;
                this.setState({})
            } else {
                this.state.isError11 = false;
                this.setState({})
            }
            if (addData.GasLeakage === "") {
                this.state.isError12 = true;
                this.setState({})
            } else {
                this.state.isError12 = false;
                this.setState({})
            }

            addData.LTIF = this.state.autoData.LTIF;
            addData.TRCF = this.state.autoData.TRCF;
            if (addData.FromDate !== "" && addData.ToDate !== "" && addData.Fatalities !== "" && addData.LTI !== "" && addData.RWC !== "" && addData.FAC !== "" && addData.MTC !== "" && addData.PropertyDamage !== "" && addData.EnvironmentalDamage !== "" && addData.MinorOilSpil !== "" && addData.ChemicalSpil !== "" && addData.GasLeakage !== "") {
                this.props.dispatch({ type: "CANCEL", data: false });       
                if (this.state.isEdit == false) {
                    this.postData(addData)
                }
                else {
                    if (addData.Id == 0 || addData.Id == undefined || addData.Id == "") {
                        this.postData(addData);
                    }
                    else {
                        this.postData(addData, addData.Id);
                    }
                }
            }
        }

    }
    postData = (data) => {
        let apiUrl = API.HSEQ_URL;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate(`/hseq/performance`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
        this.state.edited = true
    }

    render() {
        let { classes, menuToggle } = this.props;
        const { isError1, isError2, isError3, isError4, isError5, isError6, isError7, isError8, isError9, isError10, isError11, isError12, addData, isEdit } = this.state;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"HSEQ" + "1"} className='pl-3 textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="HSEQ" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>HSEQ Performance</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center">
                                    <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel}></i></td>
                                <td className="border-right text-center">
                                    <button className={classes.button} onClick={this.AddSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                </td>
                                <td className="border-right text-center">
                                    <button className={`${classes.button} pl-3`} onClick={this.AddCancel}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                </td>
                                {this.state.isEdit ?
                                    <td className="border-right text-center">
                                        <button className={`${classes.button} pl-3`} data-target="#deletepopup" data-toggle="modal" ><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>
                                    </td>
                                    :
                                    <></>
                                }
                            </tr>
                        </tbody>
                    </table>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                    <td width="95%">
                                        <button className={classes.button} onClick={this.AddSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        <button className={`${classes.button}`} onClick={this.AddCancel1} style={{ minWidth: '70px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                        {this.state.isEdit ?
                                            <button className={`${classes.button} pl-3`} data-target="#deletepopup" data-toggle="modal" style={{ minWidth: '70px' }}><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button>
                                            : <></>
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    }
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" :
                            <h6 className="col-12 m-2 mt-3">HSEQ Performance</h6>}
                        <div className={this.state.isMobile ? "row mt-1 mx-0 pr-2 pt-1" : "row mt-1 mx-3 pr-2 pt-1"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "m-0 d-flex text-right float-end"}>From Date&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError1 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            type="date"
                                            id="type-date"
                                            value={this.state.addData.FromDate && moment(this.state.addData.FromDate).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.FromDate && moment(this.state.addData.FromDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleInputChange(e, "FromDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="date"
                                            id="type-date"
                                            value={this.state.addData.FromDate && moment(this.state.addData.FromDate).format("yyyy-MM-DD")}

                                            placeholder={this.state.addData.FromDate && moment(this.state.addData.FromDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleInputChange(e, "FromDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "m-0 d-flex text-right float-end"}>To Date&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError2 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            type="date"
                                            id="type-date"
                                            value={this.state.addData.ToDate && moment(this.state.addData.ToDate).format("yyyy-MM-DD")}

                                            placeholder={this.state.addData.ToDate && moment(this.state.addData.ToDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleInputChange(e, "ToDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="date"
                                            id="type-date"
                                            value={this.state.addData.ToDate && moment(this.state.addData.ToDate).format("yyyy-MM-DD")}

                                            placeholder={this.state.addData.ToDate && moment(this.state.addData.ToDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleInputChange(e, "ToDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "m-0 d-flex text-right float-end"}>Fatalities&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError3 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            error
                                            value={this.state.addData.Fatalities}
                                            onChange={(e) => { this.handleInputChange(e, "Fatalities") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            value={this.state.addData.Fatalities}
                                            onChange={(e) => { this.handleInputChange(e, "Fatalities") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "m-0 d-flex text-right float-end"}>LTI&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError4 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            error
                                            value={this.state.addData.LTI}
                                            onChange={(e) => { this.handleInputChange(e, "LTI") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            value={this.state.addData.LTI}
                                            onChange={(e) => { this.handleInputChange(e, "LTI") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "m-0 d-flex text-right float-end"} >RWC&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError5 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            error
                                            value={this.state.addData.RWC}
                                            onChange={(e) => { this.handleInputChange(e, "RWC") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            value={this.state.addData.RWC}
                                            onChange={(e) => { this.handleInputChange(e, "RWC") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "m-0 d-flex text-right float-end"}>FAC&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError6 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            error
                                            value={this.state.addData.FAC}
                                            onChange={(e) => { this.handleInputChange(e, "FAC") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            value={this.state.addData.FAC}
                                            onChange={(e) => { this.handleInputChange(e, "FAC") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                {/* <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}> */}
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "m-0 d-flex text-right float-end"}>MTC&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError7 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            error
                                            value={this.state.addData.MTC}
                                            onChange={(e) => { this.handleInputChange(e, "MTC") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            value={this.state.addData.MTC}
                                            onChange={(e) => { this.handleInputChange(e, "MTC") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "m-0 d-flex text-right float-end"}>Property Damage&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError8 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            error
                                            value={this.state.addData.PropertyDamage}
                                            onChange={(e) => { this.handleInputChange(e, "PropertyDamage") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.PropertyDamage}
                                            onChange={(e) => { this.handleInputChange(e, "PropertyDamage") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "m-0 d-flex text-right float-end"}>Minor Oil Spill&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError10 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            error
                                            value={this.state.addData.MinorOilSpil}
                                            onChange={(e) => { this.handleInputChange(e, "MinorOilSpil") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            value={this.state.addData.MinorOilSpil}
                                            onChange={(e) => { this.handleInputChange(e, "MinorOilSpil") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>

                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "m-n2 d-flex text-right float-end"}>Environmental Damage&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError9 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            error
                                            value={this.state.addData.EnvironmentalDamage}
                                            onChange={(e) => { this.handleInputChange(e, "EnvironmentalDamage") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            value={this.state.addData.EnvironmentalDamage}
                                            onChange={(e) => { this.handleInputChange(e, "EnvironmentalDamage") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "m-0 d-flex text-right float-end"}>Chemical Spill&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError11 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            error
                                            value={this.state.addData.ChemicalSpil}
                                            onChange={(e) => { this.handleInputChange(e, "ChemicalSpil") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            value={this.state.addData.ChemicalSpil}
                                            onChange={(e) => { this.handleInputChange(e, "ChemicalSpil") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "m-0 d-flex text-right float-end"}>Gas Leakage&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError12 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            error
                                            value={this.state.addData.GasLeakage}
                                            onChange={(e) => { this.handleInputChange(e, "GasLeakage") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            value={this.state.addData.GasLeakage}
                                            onChange={(e) => { this.handleInputChange(e, "GasLeakage") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "d-flex text-right float-end"}>LTIF&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        disabled={true}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        type="number"
                                        step="any"
                                        value={this.state.autoData?.LTIF ? this.state.autoData?.LTIF : this.state.addData.LTIF}
                                        // onChange={(e) => { this.handleInputChange(e, "LTIF") }}
                                        InputProps={{
                                            className: `border-radius view-color ${classes.inputfieldAlign}`
                                        }}
                                        classes={{ root: classes.helperText }}
                                    />
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 " : "d-flex text-right float-end"}>TCRF&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12   col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        disabled={true}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        type="number"
                                        step="any"
                                        value={this.state.autoData?.TRCF ? this.state.autoData?.TRCF : this.state.addData.TRCF}
                                        // onChange={(e) => { this.handleInputChange(e, "TRCF") }}
                                        InputProps={{
                                            className: `border-radius view-color ${classes.inputfieldAlign}`
                                        }}
                                        classes={{ root: classes.helperText }}
                                    />
                                </div>
                            </div>

                            {isEdit ? <>
                                <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                        <label className={this.state.isMobile ? "d-flex pt-2  " : "d-flex text-right float-end"}>Comments&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12 col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                        <TextField
                                            multiline
                                            rows={8}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            type="number"
                                            value={this.state.addData?.Comments}
                                            onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.Comments?.length}/1000 Characters left</label>
                                    </div>
                                </div>
                            </> : <></>}
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade pt-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],

    };
}

AddHSEQPerform.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddHSEQPerform))
);

